import { render, staticRenderFns } from "./ModalDocumentosFornecedorVencedor.vue?vue&type=template&id=10ce6d80&"
import script from "./ModalDocumentosFornecedorVencedor.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentosFornecedorVencedor.vue?vue&type=script&lang=js&"
import style0 from "./ModalDocumentosFornecedorVencedor.vue?vue&type=style&index=0&id=10ce6d80&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports